import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "tagbox"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "tagtitle"
}, "設備標籤", -1);
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "tagtitle"
}, "設備大小", -1);
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "tagtitle"
}, "設備類型", -1);
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 0,
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "subtagtitle"
}, "驅動方式", -1);
const _hoisted_10 = ["onClick"];
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "subtagtitle"
}, "平臺高度", -1);
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "tagtitle"
}, "設備品牌", -1);
const _hoisted_14 = ["onClick"];
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "bottomH100"
}, null, -1);
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  class: "comBtn"
}, "確定選擇", -1);
const _hoisted_17 = [_hoisted_16];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_block = _resolveComponent("block");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_block, null, {
    default: _withCtx(() => [_hoisted_2, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tagList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "checkboxs_c",
        key: index,
        onClick: $event => $options.TagcheckChange_tag(item.Value)
      }, [_createElementVNode("span", {
        class: _normalizeClass({
          is_checked_c: $data.checkTags.includes(item.Value)
        })
      }, _toDisplayString(item.Value), 3)], 8, _hoisted_3);
    }), 128))]),
    _: 1
  }), $data.curType == 1 ? (_openBlock(), _createBlock(_component_block, {
    key: 0
  }, {
    default: _withCtx(() => [_hoisted_4, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.excavatorSizeslist, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "checkboxs_c",
        key: index,
        onClick: $event => $options.TagcheckChange_size(item.Value)
      }, [_createElementVNode("span", {
        class: _normalizeClass({
          is_checked_c: $data.checkSize.includes(item.Value)
        })
      }, _toDisplayString(item.Value), 3)], 8, _hoisted_5);
    }), 128))]),
    _: 1
  })) : _createCommentVNode("", true), $data.curType == 1 ? (_openBlock(), _createBlock(_component_block, {
    key: 1
  }, {
    default: _withCtx(() => [_hoisted_6, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.macTypelist, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "checkboxs_c",
        key: index,
        onClick: $event => $options.TagcheckChange_mac(item.Value)
      }, [_createElementVNode("span", {
        class: _normalizeClass({
          is_checked_c: $data.checkMacTypes.includes(item.Value)
        })
      }, _toDisplayString(item.Value), 3)], 8, _hoisted_7);
    }), 128)), $data.isshowother ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.DrivingMode, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "checkboxs_c",
        key: index,
        onClick: $event => $options.TagcheckChange_mac_qd(item.Value)
      }, [_createElementVNode("span", {
        class: _normalizeClass({
          is_checked_c: $data.checkmodel.includes(item.Value)
        })
      }, _toDisplayString(item.Value), 3)], 8, _hoisted_10);
    }), 128)), _hoisted_11, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.PlatformHigh, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "checkboxs_c",
        key: index,
        onClick: $event => $options.TagcheckChange_mac_gd(item.Value)
      }, [_createElementVNode("span", {
        class: _normalizeClass({
          is_checked_c: $data.checkhigh.includes(item.Value)
        })
      }, _toDisplayString(item.Value), 3)], 8, _hoisted_12);
    }), 128))])) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true), _hoisted_13, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.brandList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "checkboxs_c",
      key: index,
      onClick: $event => $options.TagcheckChange_brand(item.Value)
    }, [_createElementVNode("span", {
      class: _normalizeClass({
        is_checked_c: $data.checkhotbrand.includes(item.Value)
      })
    }, _toDisplayString(item.Value), 3)], 8, _hoisted_14);
  }), 128))]), _hoisted_15, _createElementVNode("div", {
    class: "enterprise-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.back && $options.back(...args))
  }, _hoisted_17)]);
}